import { useRef } from "react";

/**
 * Magnetic effect disabled  -  buttons stay in place to avoid the crossover
 * animation seen when two MagneticButtons sit close together.
 * The hook is kept so call sites don't need to change.
 */
export function useMagnetic(_strength = 0.3, _radius = 90) {
  const ref = useRef(null);
  return ref;
}
